import { SAMPLE } from "../constants";

const initialState = {
  sample: null,
  samples: [],
  isLoadingSamples: false,
  createdSample: false,
  updatedSample: false,
  isLoadingSample: false,
  error: null,
};
const sampleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SAMPLE.SAMPLE_GET_ALL:
      return {
        ...state,
        isLoadingSamples: true,
        error: null,
      };
    case SAMPLE.SAMPLE_GET_ALL_FAILURE:
      return {
        ...state,
        isLoadingSamples: false,
        error: action.payload,
      };
    case SAMPLE.SAMPLE_GET_ALL_SUCCESS:
      return {
        ...state,
        isLoadingSamples: false,
        samples: action.payload,
        error: null,
      };
    case SAMPLE.SAMPLE_GET_ONE:
      return {
        ...state,
        isLoadingSample: true,
        error: null,
      };
    case SAMPLE.SAMPLE_GET_ONE_FAILURE:
      return {
        ...state,
        isLoadingSample: false,
        error: action.payload,
      };
    case SAMPLE.SAMPLE_GET_ONE_SUCCESS:
      return {
        ...state,
        isLoadingSample: false,
        sample: action.payload,
        error: null,
      };
    case SAMPLE.SAMPLE_CREATE:
      return {
        ...state,
        createdSample: false,
        isLoadingSample: true,
      };
    case SAMPLE.SAMPLE_CREATE_FAILURE:
      return {
        ...state,
        isLoadingSample: false,
        error: action.payload,
      };
    case SAMPLE.SAMPLE_CREATE_SUCCESS:
      return {
        ...state,
        createdSample: true,
        isLoadingSample: false,
        sample: action.payload,
        error: null,
      };
    case SAMPLE.SAMPLE_UPDATE:
      return {
        ...state,
        updatedSample: false,
        isLoadingSample: true,
      };
    case SAMPLE.SAMPLE_UPDATE_FAILURE:
      return {
        ...state,
        isLoadingSample: false,
        error: action.payload,
      };
    case SAMPLE.SAMPLE_UPDATE_SUCCESS:
      return {
        ...state,
        updatedSample: true,
        isLoadingSample: false,
        sample: action.payload,
        error: null,
      };
    default:
      return state;
  }
};
export default sampleReducer;
